import { useCallback, useEffect, useState } from "react";
import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/esm/Button";
import moment from "moment";
import servicioToken from "../../../servicios/servicioToken";
import servicioSesion from "../../../servicios/servicioSesion";

const VerificadorDeSesion = ({ children }) => {
  const [mostrarModal, setMostrarModal] = useState(false);
  const [cuentaRegresiva, setCuentaRegresiva] = useState(null);

  const cerrarSesion = useCallback(() => {
    setMostrarModal(true);
    setCuentaRegresiva(0);
    servicioSesion.cerrarSesion();
  }, []);

  const extenderSesion = useCallback(() => {
    setMostrarModal(false);
    setCuentaRegresiva(null);
  }, []);

  useEffect(() => {
    const eventos = ["mousemove", "click", "scroll", "keydown"];
    let guardarFechaExpiracionTimeout;

    const guardarFechaDeExpiracion = () => {
      servicioSesion.guardarFechaDeExpiracion();
    };

    const actualizarFechaDeExpiracion = () => {
      if (guardarFechaExpiracionTimeout) {
        clearTimeout(guardarFechaExpiracionTimeout);
      }

      guardarFechaExpiracionTimeout = setTimeout(guardarFechaDeExpiracion, 300);
    };

    const cargarEventos = () => {
      eventos.forEach((item) => {
        window.addEventListener(item, actualizarFechaDeExpiracion);
      });
    };

    const verificarSiSesionEstaPorExpirar = () => {
      if (!mostrarModal) {
        const fechaExpiracion = servicioSesion.obtenerFechaExpiracion();
        const minutoAntesQueSesionExpire = fechaExpiracion - 60000;

        if (Date.now() >= minutoAntesQueSesionExpire) {
          setMostrarModal(true);
        }
      }
    };

    const fechaExpiracionOriginal = servicioSesion.obtenerFechaExpiracion();

    const gestionarExpiracionDeSesion = () => {
      if (mostrarModal) {
        const fechaExpiracion = servicioSesion.obtenerFechaExpiracion();
        const seExtendioLaFechaDeExpiracion =
          fechaExpiracionOriginal !== fechaExpiracion;

        if (seExtendioLaFechaDeExpiracion) {
          extenderSesion();
          return;
        }

        const tiempoRestante = fechaExpiracion - Date.now();
        setCuentaRegresiva(tiempoRestante);

        if (tiempoRestante <= 0) {
          cerrarSesion();
        }
      }
    };

    const controlarCambiosEnStorage = (evento) => {
      const fechaExpiracion = servicioSesion.obtenerFechaExpiracion();
      const token = servicioToken.obtenerToken();

      if (!fechaExpiracion) {
        cerrarSesion();
        return;
      }

      if (!token) {
        window.location.href = "/cic_externo/SesionDesconectada/";
        return;
      }
    };

    if (!mostrarModal) {
      guardarFechaDeExpiracion();
      cargarEventos();
    }

    window.addEventListener("storage", controlarCambiosEnStorage);

    const intervalVerificarSesion = setInterval(
      verificarSiSesionEstaPorExpirar,
      10000
    );
    const intervalExpiracionSesion = setInterval(
      gestionarExpiracionDeSesion,
      1000
    );

    return () => {
      clearInterval(intervalVerificarSesion);
      clearInterval(intervalExpiracionSesion);

      eventos.forEach((item) => {
        window.removeEventListener(item, actualizarFechaDeExpiracion);
      });

      window.removeEventListener("storage", controlarCambiosEnStorage);
    };
  }, [mostrarModal, extenderSesion, cerrarSesion]);

  return (
    <>
      {cuentaRegresiva !== null ? (
        <Modal show={mostrarModal} backdrop="static" keyboard={false}>
          <Modal.Header>
            <Modal.Title>
              <i className="fas fa-exclamation-triangle text-warning"></i>{" "}
              <strong>Su sesión está a punto de expirar</strong>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {cuentaRegresiva > 0 ? (
              <p className="mb-0">
                Su sesión se desconectará automáticamente en{" "}
                <strong>{moment(cuentaRegresiva).format("mm:ss")}</strong>
              </p>
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <div
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                />
                Cerrando sesión...
              </div>
            )}
          </Modal.Body>
          {cuentaRegresiva > 0 ? (
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={cerrarSesion}>
                Cerrar sesión
              </Button>
              <Button variant="primary" onClick={extenderSesion}>
                Extender sesión
              </Button>
            </Modal.Footer>
          ) : null}
        </Modal>
      ) : null}

      {children}
    </>
  );
};

export default VerificadorDeSesion;
